// src/hooks/useOwnerCouncilTeams.ts — server-backed Council teams + eligibility.
//
// Carries `refetch` because this section writes: the eligibility list is a
// snapshot of server state and goes stale the moment a sanction or a Council
// decision strips a headship, so every mutation is followed by a re-read rather
// than a client-side patch.
import { useOwnerList } from './useOwnerList';
import { ownerService } from '@/core/services/ownerService';

export function useOwnerCouncilTeams() {
  return useOwnerList(() => ownerService.getCouncilTeams());
}
